import { uniqWith } from "lodash";

import type { NormalizedTripStopAndTransfers } from "@app/components/itinerary/types";
import type { NapiV2CartSegment } from "@app/types/napi-v2-cart-types";

export const isOperatorNameViaRail = (operator_name: string = "") =>
  /via rail/i.test(operator_name);

export function getMappedOperatorsFromTripStopsAndTransfers(
  trip_stops_and_transfers: NormalizedTripStopAndTransfers
) {
  const operators = trip_stops_and_transfers.flat().map(stop => stop.operator);

  // @ts-expect-error TS18048 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
  return uniqWith(operators, (op1, op2) => op1.id === op2.id);
}

export function getMappedOperatorsFromCartSegments(
  cart_segments: NapiV2CartSegment[]
) {
  const operators = cart_segments.map(segment => segment.operator);

  return uniqWith(operators, (op1, op2) => op1.id === op2.id);
}
